module.exports = __webpack_public_path__ + "img/4Cards_2x.65d2df29.png";